<template>
  <div>
    <h5 class="mb-3">
      {{ dataComponent.name }}
    </h5>

    <div class="d-flex align-items-center mt-3">
      <b-button
        class="btn grey btn-import-form m__r--5"
        disabled
      >
        <i class="fa fa-plus fa-lg"/> Add
      </b-button>
      <j-select
        v-model="select_type"
        :options="[]"
        :disabled="true"
        :error-required="false"
        placeholder="Filter By"
        class="m__r--5"
        style="width: 96px;"
      />
      <b-form-input
        :disabled="true"
        placeholder="Search"
        style="width: 250px; height: 35px"
      />
    </div>

    <!-- Columns -->
    <div class="columns mt-3">
      <div class="d-flex align-items-center">
        <div
          v-for="column in columns"
          :key="column"
          class="column"
        >
          <div
            class="header-list"
            style="cursor: default !important;"
          >
            <div class="column-name">{{ column }}</div>
          </div>
          <div
            v-for="index in 4"
            :key="index"
            :class="{'bg-gray': index === 2 || index === 4}"
            class="column-preview"
            style="cursor: default !important;"
          >
            <div class="content-preview"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      select_type: 'null',
      columns: [
        'NAME',
        'USER ID',
        'USER COMPANY ID',
        'ROLE',
        'CREATED DATE',
        'UPDATED DATE',
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dummy/DummyUserSetup.vue